
function replaceUnicodeMinus(str: string) {
  return str.replace(/\u2212/g, '-');
}

const browserLangSeparator = (1.1).toLocaleString().substr(1, 1);
export function GetDecimalSeparator(langCode: string | undefined) {
  if (langCode != null && Intl.NumberFormat != null) {
    return new Intl.NumberFormat(langCode).format(1.1).substr(1, 1);
  }
    
  return browserLangSeparator;
}

export function NumberAsString(val: number | null, langCode?: string) {
  return GetNumberAsTextFormatter(langCode)(val);
}

export function GetNumberAsTextFormatter(langCode?: string) {
  const formatter =  langCode != null && Intl.NumberFormat != null ? new Intl.NumberFormat(langCode, { useGrouping: false }) : null;
  return formatter != null 
    ? (val: number | null) => val != null ? replaceUnicodeMinus(formatter.format(val)) : ''
    : (val: number | null) => val != null ? replaceUnicodeMinus(Number(val).toLocaleString(undefined, { useGrouping: false })) : '';
}

export function NumberAsStringFull(val: number | null, langCode?: string) {
  const formatter = langCode != null && Intl.NumberFormat != null ? new Intl.NumberFormat(langCode) : null;
  const formatted = val != null ? (formatter != null ? formatter.format(val) : Number(val).toLocaleString()) : '';
  return replaceUnicodeMinus(formatted);
}

export function GetNumberAsTextFormatterFixed(digits: number, langCode?: string) {
  const formatter =  langCode != null && Intl.NumberFormat != null ? new Intl.NumberFormat(langCode, { useGrouping: false, maximumFractionDigits: digits, minimumFractionDigits: digits }) : null;
  return formatter != null 
    ? (val: number | null) => val != null ? replaceUnicodeMinus(formatter.format(val)) : ''
    : (val: number | null) => val != null ? replaceUnicodeMinus(Number(val).toLocaleString(undefined, { useGrouping: false, maximumFractionDigits: digits, minimumFractionDigits: digits })) : '';
}